"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconReportError = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconReportError = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M13.324 5.142h-2.15v6.089h2.15V5.142Zm-1.07 7.154a1.035 1.035 0 0 0-1.063 1.053 1.036 1.036 0 0 0 1.054 1.062 1.036 1.036 0 0 0 1.062-1.053 1.036 1.036 0 0 0-1.053-1.062Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 1.5v20.689L6.189 18H22.6V1.5H2Zm18.45 14.35H5.3l-1.15 1.16V3.65h16.3v12.2Z"
}));
exports.IconReportError = IconReportError;
//# sourceMappingURL=IconReportError.js.map